import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import { IsSectionVisible } from "../../../utils/helper";
import { SECTIONS } from "../../../constants/appConstants";
import { useHistory } from "react-router-dom";
import AssignmentIcon from "@material-ui/icons/Assignment";
import SettingIcon from "@material-ui/icons/Settings";
import DashboardOutlinedIcon from "@material-ui/icons/DashboardOutlined";
import ContactsOutlined from "@material-ui/icons/ContactsOutlined";
import RadioOutlined from "@material-ui/icons/RadioOutlined";
import EmailOutlined from "@material-ui/icons/EmailOutlined";
import LocalHospitalOutlinedIcon from "@material-ui/icons/LocalHospitalOutlined";
import AssessmentOutlinedIcon from "@material-ui/icons/AssessmentOutlined";
import Badge from "../../../public/img/common/securityBadge.svg";
import ScreenSearchDesktopOutlinedIcon from "@material-ui/icons/PageviewOutlined";
import WelcomeLogo from "../../../public/img/common/welcome.jpg";

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: "#003865"
  }
}));
/**
 * Used for Rendering Mobile view Navigation for Tenant
 * @returns MobileViewNavTenant Component
 */
export default function MobileViewNavTenant() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const history = useHistory();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleNavChange = page => {
    history.push(page);
  };

  /** Creating Navigation Tab based on Access Permission */
  return (
    <div className={classes.root}>
      <AppBar position={"static"}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant={"scrollable"}
          scrollButtons={"off"}
          aria-label={"scrollable prevent tabs example"}
        >
          {IsSectionVisible(SECTIONS.DASHBOARD) && (
            <Tab
              icon={<DashboardOutlinedIcon />}
              aria-label={"Dashboard"}
              onClick={() => {
                handleNavChange("/Dashboard");
              }}
            />
          )}
          {IsSectionVisible(SECTIONS.WELCOME) && (
            <Tab
              icon={
                <img
                  style={{
                    width: "27px",
                    height: "28px"
                  }}
                  src={WelcomeLogo}
                  alt={"logo"}
                />
              }
              aria-label={"welcome"}
              onClick={() => {
                handleNavChange("/welcome");
              }}
            />
          )}
          {IsSectionVisible(SECTIONS.TENANT) && (
            <Tab
              icon={<ContactsOutlined />}
              aria-label={"tenant"}
              onClick={() => {
                handleNavChange("/tenant");
              }}
            />
          )}
          {IsSectionVisible(SECTIONS.REQUEST) && (
            <Tab
              icon={<RadioOutlined />}
              aria-label={"request"}
              onClick={() => {
                handleNavChange("/request");
              }}
            />
          )}

          {IsSectionVisible(SECTIONS.SDC_GRANT_ACCESS) && (
            <Tab
              icon={<ScreenSearchDesktopOutlinedIcon />}
              aria-label={"sdcgrantaccess"}
              onClick={() => {
                handleNavChange("/sdcgrantaccess");
              }}
            />
          )}

          {IsSectionVisible(SECTIONS.COMMUNICATION) && (
            <Tab
              icon={<EmailOutlined />}
              aria-label={"communication"}
              onClick={() => {
                handleNavChange("/communication");
              }}
            />
          )}

          {IsSectionVisible(SECTIONS.HSE_INCIDENT_MENU) && (
            <Tab
              icon={
                <LocalHospitalOutlinedIcon
                  style={{ color: "red", width: "26px", fontSize: "27px" }}
                />
              }
              aria-label={"observation"}
              onClick={() => {
                handleNavChange("/observation");
              }}
            />
          )}
          {IsSectionVisible(SECTIONS.SECURITY_INCIDENT) && (
            <Tab
              icon={
                <img
                  style={{
                    width: "27px",
                    height: "28px",
                    filter: "brightness(0) invert(1)"
                  }}
                  src={Badge}
                  alt={"logo"}
                />
              }
              aria-label={"securityIncident"}
              onClick={() => {
                handleNavChange("/securityIncident");
              }}
            />
          )}
          {(IsSectionVisible(SECTIONS.FACILITY_PERFORMANCE) ||
            IsSectionVisible(SECTIONS.FINANCIAL) ||
            IsSectionVisible(SECTIONS.HEALTH_AND_SAFETY) ||
            IsSectionVisible(SECTIONS.MAINTENANCE) ||
            IsSectionVisible(SECTIONS.SECURITY_AND_OPERATION) ||
            IsSectionVisible(SECTIONS.SITE_PROFILE) ||
            IsSectionVisible(SECTIONS.STAFFING)) && (
            <Tab
              icon={<AssessmentOutlinedIcon />}
              aria-label={"KPI"}
              onClick={() => {
                handleNavChange("/kpi");
              }}
            />
          )}

          {IsSectionVisible(
            SECTIONS.REPORTING,
            SECTIONS.REPORTING,
            SECTIONS.ADD_EDIT
          ) && (
            <Tab
              icon={<AssignmentIcon />}
              aria-label={"reporting"}
              onClick={() => {
                handleNavChange("/reporting");
              }}
            />
          )}

          {IsSectionVisible(SECTIONS.CONFIGURATION) && (
            <Tab
              icon={<SettingIcon />}
              aria-label={"configurations"}
              onClick={() => {
                handleNavChange("/configurations");
              }}
            />
          )}

          {IsSectionVisible(SECTIONS.ABOUT_US) && (
            <Tab
              icon={<InfoIcon />}
              aria-label={"aboutUs"}
              onClick={() => {
                handleNavChange("/aboutUs");
              }}
            />
          )}
        </Tabs>
      </AppBar>
    </div>
  );
}
